import { create } from 'zustand'

interface BreadcrumbStore {
  extra: string | null
  setExtra: (label: string | null) => void
}

export const useBreadcrumbStore = create<BreadcrumbStore>((set) => ({
  extra: null,
  setExtra: (label) => set({ extra: label }),
}))
